import React    from "react";
import template from "./Awards.jsx";

class Awards extends React.Component {
  render() {
    return template.call(this);
  }
}

export default Awards;
